<div style=" text-align: -webkit-center;text-align: -moz-center; margin-top: 3rem;">

  <div class="card" style="width: 70%; min-width: 30rem">
    <div *ngIf="done">
    <h1 *ngIf="!testCompleted" style="margin-bottom: 0px; font-size: 2.8em;">{{'PS_T1' | translate}}</h1>
    <div *ngIf="!testCompleted"
      style="display: flex;  margin-bottom: 2rem; margin-top: 1rem; justify-content: center; width: 75%; padding: 3px 0px;">
      <p
        style="margin-top: 3px; margin-bottom: 1px; font-size: 1.3em;">
        {{'PS_SUBT' | translate}}
      </p>
    </div>
  </div>
    <!--ALREADY COMPLETED TEST-->
    <div *ngIf="!done && charged2">
      <p style="font-size: x-large; font-weight: 500;"> {{'ALREADY_DONE_SURVEY' | translate}} </p>
    </div>
    <!--SPINNER WHILE FETCHING DATA-->
    <div *ngIf="loading" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <div *ngIf="done">
      <!--FINISHED SURVEY MESSAGE-->
      <div *ngIf="testCompleted" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
        <p style="font-size: 1.5em; font-family: akzidenz-grotesk-light;">{{'SUCCESS_SURVEY' | translate}}</p>
      </div>
      
      <div *ngIf="!loading && !testCompleted" id="questions" style="max-height: 40rem; overflow-y: scroll;"
        class="scrollableBar">
        <table mat-table [dataSource]="questions" class="mat-elevation-z8" style="box-shadow: none;">

          <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

          <!-- Position Column -->
          <ng-container matColumnDef="question_no">
            <th mat-header-cell *matHeaderCellDef> {{'PS_Q' | translate}} </th>
            <td mat-cell *matCellDef="let element" style="display: flex; height: inherit;">
              <p style="margin-right: 0.5rem; font-family: akzidenz-grotesk-bold; font-weight: 900;">
                {{element.question_no}}. </p>
              <p style="text-align: left;">{{element.question}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="Answers">
            <th mat-header-cell *matHeaderCellDef> {{'PS_ANS' | translate}} </th>
            <td mat-cell *matCellDef="let element, index">
              
                <!--<mat-checkbox class="example-margin" [checked]="answer[element.question_no-1][0]"
                  (change)="setChecked($event.checked, element.question_no-1, 0)"></mat-checkbox>-->
                  <span style="display:flex;">
                  <button mat-raised-button style=" margin-left: 5px;"
                  [ngClass]="{'clicked': answer[element.question_no-1][0]}" (click)="select(element.question_no-1, 0)">
                  {{lowercaseString('MEM_YES' | translate)}}
                </button>

                <button mat-raised-button style="  margin-left: 5px;"
                [ngClass]="{'clicked': answer[element.question_no-1][1]}" (click)="select(element.question_no-1, 1)">
                {{lowercaseString('MEM_NO' | translate)}}
              </button>
            </span>
              
            </td>
          </ng-container>


          'Answers']

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div style="
  text-align: center;
  margin: 1rem;">
        <button mat-raised-button style="background-color: #333333; color: white; margin-bottom: 21.44px;"
          *ngIf="(index < questions.length - 1) && !isDisabled && !testCompleted" (click)="onSubmit()">
          {{'SUBMIT' | translate}}
        </button>
        <button mat-raised-button *ngIf="(index < questions.length - 1) && isDisabled && !testCompleted"
          (click)="onSubmit()" disabled>
          {{'SUBMIT' | translate}}
        </button>

      </div>
    </div>
  </div>
</div>